export var ParkingLotRemarkType;
(function (ParkingLotRemarkType) {
    ParkingLotRemarkType["Other"] = "OTHER";
})(ParkingLotRemarkType || (ParkingLotRemarkType = {}));
//# sourceMappingURL=index.js.map